import { AutogenModelBrkQualDetail, AutogenRowBrkQualDetail } from "./autogen/AutogenModelBrkQualDetail";

export class ModelBrkQualDetail extends AutogenModelBrkQualDetail<RowBrkQualDetail> {
	constructor() {
		super(RowBrkQualDetail);
	}
}

export class RowBrkQualDetail extends AutogenRowBrkQualDetail {
}